import React from "react";
import MuiTextField from "@material-ui/core/TextField";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { Rifm } from "rifm";
import { AddPropertyFieldComponent } from "../property/PropertyField";
import { getFieldStatus } from "./common";

const MaskedTextField = withStyles({}, { name: "LcMaskedTextField" })(
  ({
    classes,
    name,
    label: labelProp = name,
    format,
    refuse,
    accept,
    mask,
    disabled: disabledProp,
    value: valueProp,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    ...props
  }) => (
    <FieldComponent name={name}>
      {({ field, form }) => {
        const { error, hasError, disabled, label, value } = getFieldStatus(
          form,
          field,
          valueProp,
          labelProp,
          disabledProp
        );

        function handleChange(val) {
          form.setFieldValue(name, val);
        }

        const fieldVal = value === undefined || value === null ? "" : value;

        return (
          <Rifm
            accept={accept}
            mask={mask && mask(fieldVal)}
            refuse={refuse}
            value={fieldVal}
            onChange={handleChange}
            format={format}
          >
            {({ value: maskedValue, onChange }) => (
              <MuiTextField
                label={label}
                name={name}
                onBlur={field.onBlur}
                onChange={onChange}
                value={maskedValue}
                error={hasError}
                helperText={hasError && error}
                disabled={disabled}
                {...props}
              />
            )}
          </Rifm>
        );
      }}
    </FieldComponent>
  )
);

AddPropertyFieldComponent("masked", MaskedTextField);

export default MaskedTextField;
